export default theme => ({
  root: {
    height: '100%',
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .rc-menu-submenu-title': {
      padding: 0
    }
  },
  newMenu: {
    zIndex: 1002
  },
  newButton: {
    '& span': {
      marginRight: '0 !important'
    }
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  agents: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginTop: 12
  },
  agent: {
    border: `1px solid ${theme.colors.grey[100]}`,
    borderRadius: 8,
    padding: 16,
    boxSizing: 'border-box',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: theme.colors.actionMinor[50],
      '& $deleteIcon': {
        opacity: 1
      }
    }
  },
  agentName: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  agentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  deleteIcon: {
    cursor: 'pointer',
    opacity: 0,
    transition: 'opacity 0.2s ease'
  },
  emptyView: {
    marginTop: 40
  },
  tooltip: {
    '& .hoi-poi-tooltip-content': {
      maxWidth: '400px'
    },
    '& .hoi-poi-tooltip-inner': {
      wordBreak: 'break-all'
    }
  }
});